import { MostSearchedRegionsContentHeadingProps } from 'sly/agentsPage/components/AgentsContent/MostSearchedRegions/MostSearchedRegionsContent/MostSearchedRegionsContentHeading/MostSearchedRegionsContentHeading.types';
import Heading from 'sly/system/Heading';

export default function MostSearchedRegionsContentHeading({
  title,
}: MostSearchedRegionsContentHeadingProps) {
  return (
    <Heading
      as='h3'
      className='mb-4 text-[1.25rem] font-medium text-white'
      font='font-b-m'
      data-tp-id='gen-Heading-3434489e-2b44-43a8-9f0b-0563a92b5a25'
    >
      {title}
    </Heading>
  );
}
